<template>
  <div
    :id="`business-card-${index}`"
    v-track-visibility="{ metadata: getMetadata() }"
    :class="cardClasses"
  >
    <Header :company="company" />

    <div class="card-body w-full">
      <UspBadges v-if="showUsps" class="mb-4" :usps="company.usps" />
      <ContactLinks
        :index="index"
        :company="company"
        :partner-plan-label="partnerPlan.label"
        :get-click-metadata="getClickMetadata"
      />
      <slot name="body-content" />
    </div>

    <Footer
      :company="company"
      :index="index"
      :get-click-metadata="getClickMetadata"
    />
  </div>
</template>

<script>
import ContactLinks from 'chimera/all/page/thankYou/businessCard/partials/ContactLinks.vue'
import Footer from 'chimera/all/page/thankYou/businessCard/partials/Footer.vue'
import UspBadges from 'chimera/all/page/thankYou/businessCard/partials/UspBadges.vue'
import usesPartnerPlan from 'chimera/all/mixins/usesPartnerPlan'
import Header from './partials/Header.vue'

export default {
  name: 'BaseBusinessCard',

  components: {
    UspBadges,
    Header,
    Footer,
    ContactLinks,
  },

  mixins: [usesPartnerPlan],

  props: {
    company: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },
  },

  computed: {
    /**
     * @returns {object}
     */
    partnerPlan() {
      return this.getPartnerPlan(this.company.plan)
    },

    /**
     * @returns {boolean}
     */
    showUsps() {
      return !!(this.partnerPlan.showUsps && this.company.usps?.length)
    },

    /**
     * @returns {string[]}
     */
    cardClasses() {
      return [
        'card',
        'business-card',
        `business-card--${this.partnerPlan.label.toLowerCase()}`,
      ]
    },
  },

  methods: {
    /**
     * @returns {object}
     */
    getMetadata() {
      const metadata = {
        elementIndex: this.index,
        elementGroup: 'businessCard',
      }

      metadata.partnerPlan = this.partnerPlan.label

      return metadata
    },

    /**
     * @param {'address'|'website'|'email'|'phone'} linkType
     * @returns {object}
     */
    getClickMetadata(linkType) {
      return {
        linkType,
        ...this.getMetadata(),
      }
    },
  },
}
</script>
